import { useState } from 'react';
import { hitungIncomeBased, hitungNeedBased, getRekomendasiProduk, estimasiPremi } from '../utils/calculations';

const initialState = {
  formData: null,
  incomeBased: 0,
  needBased: 0,
  rekomendasiUP: 0,
  rekomendasiProduk: '',
  estimasiPremiRendah: 0,
  estimasiPremiTinggi: 0,
  ringkasan: {}
};

const useCalculator = () => {
  const [calculationData, setCalculationData] = useState(initialState);

  const calculateNeeds = (formData) => {
    const {
      usia,
      penghasilan,
      pengeluaranBulanan,
      danaMasaDepan,
      totalKewajiban,
      totalAset,
      persentaseProteksi = 80,
      persentasePengeluaran = 70,
      lamaKebutuhan = 15
    } = formData;

    // Hitung kedua metode
    const incomeBased = hitungIncomeBased(penghasilan, usia, persentaseProteksi);
    
    const needBased = hitungNeedBased({
      pengeluaranBulanan,
      persentasePengeluaran,
      lamaKebutuhan,
      danaMasaDepan,
      totalKewajiban,
      totalAset
    });

    // Rekomendasi UP (ambil yang terbesar)
    const rekomendasiUP = Math.max(incomeBased, needBased);

    // Rekomendasi produk
    const rekomendasiProduk = getRekomendasiProduk(usia);

    // Estimasi premi
    const estimasiPremiRendah = estimasiPremi(usia, rekomendasiUP) * 0.8;
    const estimasiPremiTinggi = estimasiPremi(usia, rekomendasiUP) * 1.2;

    // Ringkasan untuk output
    const ringkasan = {
      usia,
      penghasilan,
      pengeluaranBulanan,
      danaMasaDepan,
      totalKewajiban,
      totalAset
    };

    const results = {
      formData,
      incomeBased,
      needBased,
      rekomendasiUP,
      rekomendasiProduk,
      estimasiPremiRendah,
      estimasiPremiTinggi,
      ringkasan
    };

    setCalculationData(results);
    return results;
  };

  const resetCalculator = () => {
    setCalculationData(initialState);
  };

  return {
    calculationData,
    calculateNeeds,
    resetCalculator
  };
};

export default useCalculator;